
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom';
import Home from './pages/Home';
import './App.css';
import css from "./pages/Home.module.css";
import Contatos from "./pages/Contatos";
import TratamentosPage from "./pages/TratamentosPage";

function App() {
  return (
      <div className={"App"}>
          <a href="https://api.whatsapp.com/send/?phone=5534999152255&text&type=phone_number&app_absent=0&utm_source=ig"><img className={css.zaplogo} src="/zaplogo.png" alt=""/></a>
          <BrowserRouter>
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contatos" element={<Contatos />} />
              <Route path="/tratamentos" element={<TratamentosPage />} />
          </Routes>
      </BrowserRouter>
      </div>
  );
}

export default App;
